<script>
	import { onMount } from 'svelte'
	import { routerStore } from './stores/router-store.js'
	import { authStoreInit } from './stores/auth-store.js'
	import { timesStoreInit } from './stores/times-store.js'
	import { projectsStoreInit } from './stores/projects-store.js'
	import { initServiceWorker } from './helpers/service-worker.js'
	
	import SignUpView from './auth/sign-up-view.svelte'
	import SignInView from './auth/sign-in-view.svelte'
	import TimelogView from './timelog/timelog-view.svelte'
	import ReportsView from './reports/reports-view.svelte'
	import SettingsView from './settings/settings-view.svelte'


	export let name;

	onMount(async () => {
		await initServiceWorker()
		authStoreInit()
		timesStoreInit()
		projectsStoreInit()
	})
</script>

<main>
	{#if $routerStore.view === 'overview'}
		<SignInView />
	{:else if $routerStore.view === 'sign-up'}
		<SignUpView />
	{:else if $routerStore.view === 'sign-in'}
		<SignInView />
	{:else if $routerStore.view === 'timelog'}
		<TimelogView />
	{:else if $routerStore.view === 'reports'}
		<ReportsView />
	{:else if $routerStore.view === 'settings'}
		<SettingsView />
	{/if}
</main>

<style>
	
</style>